const recordatorioEnumerators = {
  tipo: [
    'days',
    'months',
    'years',
  ],
};

export default recordatorioEnumerators;
